// extracted by mini-css-extract-plugin
export default {"root":"pill-module___root___fc2ba990","small":"pill-module___small___f82a92e1","dark":"pill-module___dark___a0b1fd5a"};